import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useT } from '@transifex/react';
import { SingleSelect } from '@raisin/components-lib';
import { getDistributor } from '@raisin/cp-utils';
import { BANK_EVENTS } from 'eventsTracking';
import { handleBankListSort } from 'eventsTracking/BankList/onListOfBanksSorted';
import { sortingOptions } from 'types';
import messages from '../../../../../messages';

const Sort = ({ sortBy, onChange }) => {
  const t = useT();
  const distributorId = getDistributor();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.between('xs', 'lg'));

  return (
    <SingleSelect
      width={isMobile ? '100%' : 300}
      labelText={t(messages.bankListSortByLabel)}
      value={sortBy}
      onChange={(value) => {
        onChange(value);
        handleBankListSort({
          sortingCriteria: value as string,
          distributorId,
          eventName: BANK_EVENTS.LIST_OF_BANKS_SORTED,
        });
      }}
      options={[
        {
          text: t(messages.bankListSortAlphabetically),
          value: sortingOptions.BANK_NAME,
        },
        {
          text: t(messages.bankListSortByRating),
          value: sortingOptions.RATING,
        },
      ]}
      testId="sort-select"
    />
  );
};

export default Sort;
